import {
  getFirstAttributeValue,
  getLatestCategory,
  type Product,
} from '@scayle/storefront-nuxt'
import type {
  TrackingEvent,
  TrackingPayload,
  TrackPromotionParams,
  ViewPromotionProductInfo,
} from '~/types/tracking'
import { getCategoryLevels, getSizeKey, resolvePageType } from '~/utils/tracking'
import type { StoryblokTrackingContent } from '~/cms/storyblok/types/storyblok.d.ts'
import useActivePromotion from '@/composables/tracking/useActivePromotion'

const usePromotionEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => {
  const currentShop = useCurrentShop()
  const { setActivePromotion } = useActivePromotion()
  const route = useRoute()

  return {
    /**
     * @deprecated in favor of trackPromotionView and trackPromotionSelect.
     * Calling this function WILL NOT push any data to the tracking queue.
    */
    trackPromotion: (
      event: TrackingEvent,
      trackableObject: StoryblokTrackingContent,
      params?: { product?: Product; url?: string },
    ) => {
      let item = {}

      if (params?.product) {
        const { product } = params

        const category = getLatestCategory(product.categories)
        const price = getLowestPrice(product.variants || [])

        const variant = product.variants?.[0]

        item = {
          item_id: product.id.toString(),
          item_sku: product.referenceKey,
          item_name: getFirstAttributeValue(product.attributes, 'name')?.label,
          item_brand: getFirstAttributeValue(product.attributes, 'brand')
            ?.label,
          item_variant: getFirstAttributeValue(product.attributes, 'color')
            ?.label,
          item_size: variant?.attributes?.size?.values,
          item_category: getCategoryLevels(product.categories).item_category,
          item_category2: getCategoryLevels(product.categories).item_category2,
          item_category3: getCategoryLevels(product.categories).item_category3,
          discount: variant
            ? getTotalAppliedReductions(
                variant.price,
                variant.price.appliedReductions,
              )?.absoluteWithTax
            : undefined,
          quantity: 1,
          currency: currentShop.value?.currency,
          ...(price?.withTax && { price: toFloat(price.withTax) }),
          ...(variant?.stock && { stock: variant?.stock.quantity }),
          ...(variant?.referenceKey &&
            getSizeKey(variant.referenceKey) && {
              item_size_key: getSizeKey(variant.referenceKey),
            }),
        }

        // storePromotion({
        //   [product.referenceKey || '']: {
        //     promotion_name: trackableObject.promotion_name || '',
        //     promotion_id: trackableObject.promotion_id || '',
        //     location_id: trackableObject.location_id || '',
        //     item_category: category?.categoryUrl || '',
        //     creative_name: trackableObject.creative_name || '',
        //     creative_slot: trackableObject.creative_slot || '',
        //   },
        // })
      } else if (params?.url && event === 'select_promotion') {
        // storeBanner({
        //   [params.url]: {
        //     promotion_name: trackableObject.promotion_name || '',
        //     promotion_id: trackableObject.promotion_id || '',
        //     location_id: trackableObject.location_id || '',
        //     creative_name: trackableObject.creative_name || '',
        //     creative_slot: trackableObject.creative_slot || '',
        //   },
        // })
      }

      // track(event, {
      //   items: [{ ...trackableObject, ...item }],
      // })
    },

    trackPromotionSelect: (params: TrackPromotionParams) => {
      const { id, name, pageType, promoType, position, creativeNameSb } = params
      const resolvedPageType = pageType ?? resolvePageType(route)

      if (!resolvedPageType) {
        console.log('No page type found for promotion select; params: ', params)
        return
      }

      const promotion = {
        promotion_id: id,
        promotion_name: name,
        creative_name: `${resolvedPageType}_${promoType}`,
        creative_slot: `${promoType}_pos${position}`,
        creative_name_storyblok: creativeNameSb
      }
      track('select_promotion', promotion)
      setActivePromotion(promotion)
    },

    trackPromotionView: (params: TrackPromotionParams) => {
      const { id, name, pageType, promoType, position, creativeNameSb } = params
      const resolvedPageType = pageType ?? resolvePageType(route)

      if (!resolvedPageType) {
        console.log('No page type found for promotion view; params: ', params)
        return
      }

      const promotion = {
        promotion_id: id,
        promotion_name: name,
        creative_name: `${resolvedPageType}_${promoType}`,
        creative_slot: `${promoType}_pos${position}`,
        creative_name_storyblok: creativeNameSb
      }
      track('view_promotion', promotion)
    },

     /**
     * @deprecated in favor of multiple calls to trackPromotionView and trackPromotionSelect.
     * Calling this function WILL NOT push any data to the tracking queue.
    */
    trackPromotionForMultipleItems: (
      event: TrackingEvent,
      trackingPayload:
        | Array<StoryblokTrackingContent & ViewPromotionProductInfo>
        | Array<StoryblokTrackingContent>,
      params?: { url?: string },
    ) => {
      trackingPayload.map((payload) => {
        if ('item_category' in payload) {
          // storePromotion({
          //   [payload.item_category5 || '']: {
          //     promotion_name: payload.promotion_name || '',
          //     promotion_id: payload.promotion_id || '',
          //     location_id: payload.location_id || '',
          //     item_category: payload.item_category || '',
          //     creative_name: payload.creative_name || '',
          //     creative_slot: payload.creative_slot || '',
          //   },
          // })
        }
      })

      if (params?.url) {
        // storeBanner({
        //   [params.url]: {
        //     promotion_name: trackingPayload[0].promotion_name || '',
        //     promotion_id: trackingPayload[0].promotion_id || '',
        //     location_id: trackingPayload[0].location_id || '',
        //     creative_name: trackingPayload[0].creative_name || '',
        //     creative_slot: trackingPayload[0].creative_slot || '',
        //   },
        // })
      }

      // track(event, {
      //   items: [...trackingPayload],
      // })
    },
  }
}

export default usePromotionEvents
